import { config, createRequest, getOrderChangeHistory, type OrderChangeVO } from "@ifa/utils";

const request = createRequest({
  baseURL: config.apiBaseUrl,
});

type OrderChangeHistoryResult = OrderChangeVO | OrderChangeVO[] | null | undefined;

function hasOrderChangeHistoryData(result: OrderChangeHistoryResult) {
  if (result == null) return false;

  if (Array.isArray(result)) {
    return result.length > 0;
  }

  return !!result.changeDetails?.length;
}

export function getPendingOrderChangeHistory(orderId: number, flowRecordId: number) {
  return request<OrderChangeVO | OrderChangeVO[]>("/order/pending-change-history", {
    params: { orderId, flowRecordId },
  });
}

export async function getOrderChangeHistoryWithFallback(orderId: number, flowRecordId: number) {
  const pendingResult = await getPendingOrderChangeHistory(orderId, flowRecordId);

  if (hasOrderChangeHistoryData(pendingResult)) {
    return pendingResult;
  }

  return getOrderChangeHistory(orderId, flowRecordId);
}

export { hasOrderChangeHistoryData };
